import React from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from 'recharts';

export default function AgentPerformanceChart({ data = {}, range = '7d', onRangeChange }) {
  const sample = data[range] || [];

  return (
    <Box
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 2px 12px rgba(15,23,42,0.07)',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 2.5,
          py: 1,
          minHeight: 52,
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#fff' }}>
          Performance Overview
        </Typography>
        {/* <ToggleButtonGroup
          size="small"
          value={range}
          exclusive
          onChange={(e, val) => val && onRangeChange(val)}
          sx={{
            '& .MuiToggleButton-root': {
              color: 'rgba(255,255,255,0.6)',
              borderColor: 'rgba(255,255,255,0.15)',
              px: 1.5,
              py: 0.5,
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'none',
              '&.Mui-selected': {
                bgcolor: '#1976d2',
                color: '#fff',
                borderColor: '#1976d2',
                '&:hover': { bgcolor: '#1565c0' },
              },
              '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
            },
          }}
        >
          <ToggleButton value="today">Today</ToggleButton>
          <ToggleButton value="7d">7d</ToggleButton>
          <ToggleButton value="30d">30d</ToggleButton>
          <ToggleButton value="90d">90d</ToggleButton>
        </ToggleButtonGroup> */}
      </Box>

      {/* Chart */}
      <Box sx={{ bgcolor: '#fff', px: 1, pt: 2, pb: 1 }}>
        <Box sx={{ width: '100%', height: { xs: 200, md: 280 } }}>
          <ResponsiveContainer>
            <AreaChart data={sample} margin={{ top: 8, right: 24, left: 0, bottom: 8 }}>
              <defs>
                <linearGradient id="gradCompleted" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#2e7d32" stopOpacity={0.18} />
                  <stop offset="95%" stopColor="#2e7d32" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="gradEarnings" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#1976d2" stopOpacity={0.18} />
                  <stop offset="95%" stopColor="#1976d2" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="4 4" stroke="rgba(15,23,42,0.06)" vertical={false} />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11, fill: '#94a3b8' }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#94a3b8' }}
                axisLine={false}
                tickLine={false}
                width={44}
                tickFormatter={(v) => '₹' + v}
              />
              <Tooltip
                formatter={(value, name) => (name === 'Earnings' ? ['₹' + value, name] : [value, name])}
                contentStyle={{
                  borderRadius: 8,
                  border: 'none',
                  boxShadow: '0 4px 16px rgba(15,23,42,0.12)',
                  fontSize: 12,
                }}
              />
              <Legend
                wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
              />
              <Area type="monotone" dataKey="completed" name="Completed" stroke="#2e7d32" strokeWidth={2} fill="url(#gradCompleted)" dot={false} />
              <Area type="monotone" dataKey="earnings" name="Earnings" stroke="#1976d2" strokeWidth={2} fill="url(#gradEarnings)" dot={false} />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
}
